import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const ExternalLinkIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path
                d="M14.7628 2.42851C14.7359 2.44865 14.7158 2.77089 14.7158 3.1334V3.7913H16.9782H19.2472L14.6822 8.35633L10.1172 12.9214L10.6073 13.4047L11.0906 13.8948L15.6556 9.32975L20.2207 4.76473V7.03381V9.3029L20.9121 9.28276L21.5969 9.26262V5.83885V2.41508L18.2 2.39494C16.3337 2.38823 14.7829 2.40166 14.7628 2.42851Z"
                fill="currentColor"
            />
            <path
                d="M3.66725 3.93291C3.21746 4.10074 2.84151 4.43641 2.59984 4.87277L2.39844 5.23529L2.39844 12.7206L2.39844 20.2059L2.59984 20.5684C2.84823 21.0115 3.21746 21.3404 3.68739 21.515C4.04319 21.6492 4.20431 21.6492 11.2935 21.6492C18.5371 21.6492 18.5371 21.6492 18.9265 21.5083C19.4367 21.3136 19.8865 20.8638 20.0812 20.3536C20.2222 19.9709 20.2222 19.8904 20.2222 16.0101V12.0493H19.5508H18.8795V15.8423C18.8795 20.0783 18.8862 20.0246 18.4499 20.2059C18.0941 20.3536 4.49298 20.3536 4.13717 20.2059C3.68739 20.0179 3.70753 20.4006 3.70753 12.7206C3.70753 6.79948 3.72095 5.76563 3.80822 5.56424C3.98948 5.12787 3.93578 5.13459 8.17185 5.13459H11.9648V4.46326V3.79193L7.99059 3.79865C4.20431 3.79865 3.98948 3.80536 3.66725 3.93291Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const ExternalLinkIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path
                d="M14.7628 2.42851C14.7359 2.44865 14.7158 2.77089 14.7158 3.1334V3.7913H16.9782H19.2472L14.6822 8.35633L10.1172 12.9214L10.6073 13.4047L11.0906 13.8948L15.6556 9.32975L20.2207 4.76473V7.03381V9.3029L20.9121 9.28276L21.5969 9.26262V5.83885V2.41508L18.2 2.39494C16.3337 2.38823 14.7829 2.40166 14.7628 2.42851Z"
                fill="currentColor"
            />
            <path
                d="M3.66725 3.93291C3.21746 4.10074 2.84151 4.43641 2.59984 4.87277L2.39844 5.23529L2.39844 12.7206L2.39844 20.2059L2.59984 20.5684C2.84823 21.0115 3.21746 21.3404 3.68739 21.515C4.04319 21.6492 4.20431 21.6492 11.2935 21.6492C18.5371 21.6492 18.5371 21.6492 18.9265 21.5083C19.4367 21.3136 19.8865 20.8638 20.0812 20.3536C20.2222 19.9709 20.2222 19.8904 20.2222 16.0101V12.0493H19.5508H18.8795V15.8423C18.8795 20.0783 18.8862 20.0246 18.4499 20.2059C18.0941 20.3536 4.49298 20.3536 4.13717 20.2059C3.68739 20.0179 3.70753 20.4006 3.70753 12.7206C3.70753 6.79948 3.72095 5.76563 3.80822 5.56424C3.98948 5.12787 3.93578 5.13459 8.17185 5.13459H11.9648V4.46326V3.79193L7.99059 3.79865C4.20431 3.79865 3.98948 3.80536 3.66725 3.93291Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};
